export default __webpack_public_path__ + "static/media/trash.dc91a955.svg";